import StudentAdmin from "./StudentAdmin";

export default StudentAdmin;